import { useState } from "react";
import { useNavigate } from "react-router-dom";
import { motion } from "framer-motion";
import { api, formatApiError } from "@/lib/api";
import { Input } from "@/components/ui/input";
import { Label } from "@/components/ui/label";

export default function AdminLogin() {
    const [email, setEmail] = useState("");
    const [password, setPassword] = useState("");
    const [error, setError] = useState("");
    const [loading, setLoading] = useState(false);
    const navigate = useNavigate();

    const submit = async (e) => {
        e.preventDefault();
        setError("");
        setLoading(true);
        try {
            const res = await api.post("/auth/login", { email, password });
            localStorage.setItem("mi_admin_token", res.data.token);
            navigate("/admin");
        } catch (err) {
            setError(formatApiError(err));
        } finally {
            setLoading(false);
        }
    };

    return (
        <main className="flex min-h-screen items-center justify-center bg-monster-cream px-5">
            <motion.div
                initial={{ opacity: 0, y: 40, scale: 0.96 }}
                animate={{ opacity: 1, y: 0, scale: 1 }}
                transition={{ type: "spring", stiffness: 120, damping: 16 }}
                className="w-full max-w-md rounded-[32px] border-2 border-monster-navy bg-white p-8 shadow-sticker-lg sm:p-10"
            >
                <div className="mb-8 text-center">
                    <img src="/logo.png" alt="Monsters Inflatables logo" className="mx-auto h-20 w-20 rounded-full border-2 border-monster-navy object-cover shadow-sticker-sm" />
                    <h1 className="mt-5 font-display text-3xl font-semibold text-monster-navy">Owner Login</h1>
                    <p className="mt-1 text-sm font-semibold text-monster-navy/50">Manage your bookings, boss.</p>
                </div>
                <form data-testid="admin-login-form" onSubmit={submit} className="space-y-5">
                    <div>
                        <Label htmlFor="al-email" className="mb-2 block font-display text-sm font-semibold text-monster-navy">Email</Label>
                        <Input
                            id="al-email"
                            data-testid="admin-email-input"
                            type="email"
                            required
                            value={email}
                            onChange={(e) => setEmail(e.target.value)}
                            placeholder="MonstersInflatables@gmail.com"
                            className="rounded-xl border-2 border-monster-navy px-4 py-3 font-semibold shadow-sticker-sm"
                        />
                    </div>
                    <div>
                        <Label htmlFor="al-password" className="mb-2 block font-display text-sm font-semibold text-monster-navy">Password</Label>
                        <Input
                            id="al-password"
                            data-testid="admin-password-input"
                            type="password"
                            required
                            value={password}
                            onChange={(e) => setPassword(e.target.value)}
                            placeholder="••••••••"
                            className="rounded-xl border-2 border-monster-navy px-4 py-3 font-semibold shadow-sticker-sm"
                        />
                    </div>
                    {error && (
                        <p data-testid="admin-login-error" className="rounded-xl border-2 border-monster-red bg-red-50 px-4 py-2.5 text-sm font-bold text-monster-red">
                            {error}
                        </p>
                    )}
                    <button
                        data-testid="admin-login-submit-btn"
                        type="submit"
                        disabled={loading}
                        className="w-full rounded-full border-2 border-monster-navy bg-monster-blue py-3.5 font-display text-base font-semibold text-white shadow-sticker transition-all hover:-translate-y-0.5 active:translate-y-1 active:shadow-none disabled:opacity-60"
                    >
                        {loading ? "Logging in..." : "Log In"}
                    </button>
                </form>
                <a data-testid="admin-back-home-link" href="/" className="mt-6 block text-center text-sm font-bold text-monster-navy/50 transition-colors hover:text-monster-blue">
                    ← Back to the fun
                </a>
            </motion.div>
        </main>
    );
}
